import { Typography } from '#atoms/index';
import { useWindowSize } from '#hooks/index';

const laptop = (
  <svg
    width="33"
    height="35"
    viewBox="0 0 33 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.8327 28.3332H4.83268C3.35992 28.3332 2.16602 27.1393 2.16602 25.6665V24.3332H4.83268V12.3332C4.83268 10.8604 6.02659 9.6665 7.49935 9.6665H26.166C27.6388 9.6665 28.8327 10.8604 28.8327 12.3332V24.3332H31.4993V25.6665C31.4993 27.1393 30.3054 28.3332 28.8327 28.3332ZM7.49935 12.3332V24.3332H26.166V12.3332H7.49935Z"
      fill="#AC84FF"
    />
  </svg>
);

const camera = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.83366 8.00006C3.91298 8.00006 3.16699 8.72332 3.16699 9.61537V17.1535C3.16699 20.1273 5.65451 22.5379 8.72255 22.5379H20.167C21.0877 22.5379 21.8337 21.8146 21.8337 20.9226V13.3844C21.8337 10.4107 19.3461 8.00006 16.2781 8.00006L4.83366 8.00006Z"
      fill="#AC84FF"
    />
    <path
      d="M23.167 12.489C23.167 12.1601 23.3222 11.8491 23.5885 11.6448L28.033 8.23457C28.7611 7.67563 29.8337 8.17857 29.8337 9.07904V21.5877C29.8337 22.4882 28.7611 22.9909 28.033 22.4322L23.5885 19.022C23.3222 18.8177 23.167 18.5067 23.167 18.1775V12.489Z"
      fill="#AC84FF"
    />
  </svg>
);

const mouse = (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="9.06602"
      y="3.5665"
      width="14.2"
      height="24.8667"
      rx="5.1"
      stroke="#AC84FF"
      strokeWidth="1.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.499 4.6665L15.499 10.6665H9.49902V11.9998H15.499H16.8324H22.8324V10.6665H16.8324L16.8324 4.6665H15.499Z"
      fill="#AC84FF"
    />
  </svg>
);

const requirements = [
  {
    icon: laptop,
    text: 'Usar PC o laptop para el desarrollo del taller'
  },
  {
    icon: camera,
    text: 'Tener instalado Zoom en la misma PC o Laptop que use para el taller.'
  },
  {
    icon: mouse,
    text: 'Se recomienda usar mouse y audífonos con micrófono.'
  }
];

const GameJamRequirements = () => {
  const { isMobile } = useWindowSize();

  return (
    <section className="game-jam-requirements-Wrapper">
      <div className="game-jam-requirements">
        {/* Title */}
        <div className="game-jam-requirements__title">
          <Typography
            variant="regular regular-2 bold text-center"
            tag="h2"
            style={{ color: '#AC84FF', lineHeight: isMobile ? '44px' : '60px' }}
          >
            ¿Qué equipo necesito?
          </Typography>
        </div>

        {/* List */}
        <ul className="game-jam-requirements__list">
          {requirements.map(({ icon, text }, idx) => (
            <li key={idx} className="game-jam-requirements__list__item">
              {icon}

              <Typography
                variant="regular regular-6 md:text-center text-left"
                tag="p"
                style={{ color: '#DBD1FD', lineHeight: isMobile ? '24px' : '30px' }}
              >
                {text}
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default GameJamRequirements;
